<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" class="pr-0">
        <v-card class="mx-4 my-2">
          <v-card-title class="py-0 pb-4">
            <!-- <v-row> -->
            <v-col cols="12" md="auto" sm="auto" align-self="center">
              <p class="text-left mb-0">{{ title }}</p>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" md="auto" sm="auto" align-self="start">
              <v-text-field
                v-model="search"
                class="mb-1 mx-2 pt-1"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              
            </v-col>
            <v-col cols="12" md="auto" sm="auto" align-self="start" v-for="action in customActions" :key="action.key">
              <v-btn
                block
                :class="'pt-0 mb-1'.concat(action.class || '')"
                :color="action.color"
                elevation="1"
                :disabled="value.length == 0"
                @click="action.click"
              >
                {{action.title}}
                <v-icon right dark>{{ action.icon }}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="auto" sm="auto" align-self="start" v-if="multiDelete && showSelect">
              <v-btn
                block
                class="pt-0 mb-1 white--text"
                color="red"
                elevation="1"
                :disabled="value.length == 0"
                @click="showMultiDeleteDialog = true"
              >
                Delete
                <v-icon right dark> mdi-delete </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="auto" sm="auto" align-self="center">
          <download-excel
                v-if="canExport"
                :fetch="getExportData"
                :fields="exportFields"
                :name="getExportName"
              >
                <v-btn
                block
                  class="pt-0 mb-1"
                  :loading="export_in_progress"
                  :disabled="export_in_progress"
                  color="white"
                  elevation="1"
                >
                  Export
                  <v-icon right dark> mdi-export </v-icon>
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
              </download-excel>    
            </v-col>
            <!-- </v-row> -->

            <!-- <v-spacer></v-spacer> -->
          </v-card-title>
          <!-- filter -->
          <v-row class="mx-4">
            <v-col
              v-for="(field, index) in Object.keys(filterData)"
              :key="index"
              cols="12"
              :md="12 / Object.keys(filterData).length"
            >
              <v-autocomplete
                v-model="filterData[field].model"
                :items="filterData[field].items"
                v-if="!filterData[field].isCustom"
                small-chips
                deletable-chips
                single-line
                outlined
                color="primary"
                :label="filterData[field].label"
                multiple
                hide-details
                dense
                background-color="transparent"
                :item-value="filterData[field].itemValue"
                :item-text="filterData[field].itemText"
                class="mb-4 rounded-input"
                @change="getAllItems()"
              ></v-autocomplete>
              <slot
                v-if="filterData[field].isCustom"
                :name="'custom-filter--' + field"
              >
              </slot>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :options.sync="options"
            :items-per-page="enablePagination ? 15 : -1"
            :multi-sort="true"
            :expanded="expanded"
            :server-items-length="enablePagination ? pagination.totalCount : -1"
            @click:row="handleClick"
            :single-expand="showExpand"
            item-key="id"
            :show-expand="showExpand"
            :disable-pagination="!enablePagination"
            :hide-default-footer="!enablePagination"
            :custom-filter="allowCustomFilter ? customFilter : defaultFilter"
            class="row-pointer"
            :show-select="showSelect"
            :value="value"
            @input="$emit('input', $event)"
          >
            <template
              v-for="(index, name) in $scopedSlots"
              v-slot:[name]="data"
            >
              <slot :name="name" v-bind="data"></slot>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <DeleteConfirmationDialog 
      :visible="showMultiDeleteDialog"
      :title="`Are you sure you want to delete the selected items?`"
      description="You cannot undo this action."
      @deleteObject="multiDeleteItems"
    />
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Helper from "@utils/misc";
import api from "@api/index";
import { mapGetters, mapActions } from "vuex";
import JsonExcel from "vue-json-excel";
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog';
  
export default {
  name: "IntractDataTable",
  props: {
    value: {                 // required for v-model in Vue 2
      type: Array,
      default: () => []
    },
    enablePagination: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showExpand: {
      type: Boolean,
      default() {
        return false;
      },
    },
    dummyItems: {
      type: Array,
      default() {
        return [];
      },
    },
    expanded: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    headers: {
      type: Array,
      default() {
        return [];
      },
    },
    endpoint: {
      type: String,
      default: null,
    },
    bulkDeleteEndpoint: {
      type: String,
      default: null,
    },
    sortOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    // search: {
    //   type: String,
    //   default: "",
    // },
    tableOptions: {
      type: Object,
      default() {
        return {};
      },
    },

    filterFields: {
      type: Object,
      default: () => {},
    },
    exportFields: {
      type: Object,
      default() {
        return {};
      },
    },
    searchParameter: {
      type: String,
      default: "search"
    },
    orderParameter: {
      type: String,
      default: "ordering"
    },
    canExport: {
      type: Boolean,
      default: false,
    },
    multiDelete: {
      type: Boolean,
      default: false,
    },
    customActions: {
      type: Array,
      default: () => [],
    },
    exportUrl: {
      type: String,
      default: null,
    },
    allowCustomFilter: {
      type: Boolean,
      default: false,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],

      export_in_progress: false,
      filterData: this.filterFields,
      showMultiDeleteDialog: false,
      search: "",
      options: this.tableOptions,
      pagination: {
        totalCount: 0,
        url: this.endpoint,
      },
      snackbar: {
        visible: false,
        text: "",
      },
    };
  },
  components: {
    downloadExcel: JsonExcel,
    DeleteConfirmationDialog,
  },
  computed: {
    ...mapGetters(["accessToken", "isLoading"]),

    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },

    getExportName() {
      return Helper.getExportName();
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleClick(value) {
      this.$emit("handleClick", value);
    },
    defaultFilter(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value !== "boolean" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase()) !== -1
      );
    },

    // To get custom search in data table(espacially for expanded tables)
    customFilter(value, search, items) {
      const wordArray = search
        .toString()
        .toLowerCase()
        .split(" ")
        .filter((x) => x);
      return wordArray.every((word) =>
        JSON.stringify(Object.values(items))
          .toString()
          .toLowerCase()
          .includes(word)
      );
    },

    // queries all fee accounts
    async getAllItems() {
      if (this.dummyItems.length) {
        this.items = this.dummyItems;
        this.pagination.totalCount = this.items.length;
        return;
      }
      var url = this.pagination.url;
      if (this.search) url = Helper.addUrlParams(url, [`${this.searchParameter}=${this.search}`]);
      if (this.export_in_progress)
        url = this.exportUrl ?? Helper.addUrlParams(url, "extract=true");
      // filtering
      Object.keys(this.filterData).map((field) => {
        var fieldData = this.filterData[field];
        if (fieldData.model)
          url = Helper.addUrlParams(
            url,
            `${fieldData.param}=${fieldData.model.map((a) => a)}`
          );
      });
      var response = await api.call(this.essentials, url);
      if (this.export_in_progress) return response;
      if (response) {
        console.log(response);
        if (this.enablePagination) {
          this.items = response.results;
          this.pagination.totalCount = response.count;
          this.pagination.nextUrl = response.next;
        } else {
          this.items = response;
          // this.pagination.totalCount = response.count;
        }
        this.$emit("updateItems", this.items);
      }
    },

    async multiDeleteItems(confirm) {
      if (!confirm) {
        this.showMultiDeleteDialog = false;
        return;
      }
      this.setLoading(true);
      var response = await api.call(this.essentials, this.bulkDeleteEndpoint, api.Methods.POST, {
        delete_ids: this.value.map((item) => item.id),
      });
      if (response) {
        this.snackbar.text = "Items deleted successfully";
        this.snackbar.visible = true;
        this.getAllItems();
        this.value = [];
      }
      this.showMultiDeleteDialog = false;
    },

    async getExportData() {
      this.export_in_progress = true;
      var response = await this.getAllItems();
      this.export_in_progress = false;
      return response;
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    getParamsString() {
      var params = "";
      if (this.options.sortBy.length > 0) {
        // get url var
        params = `&${this.orderParameter}=`;
        // iterate over sortBy options and add sortby and sortdesc seperated with commas
        for (var sortOption in this.options.sortBy) {
          params +=
            (this.options.sortDesc[sortOption] ? "" : "-") +
            this.options.sortBy[sortOption];
          if (sortOption != this.options.sortBy.length - 1) params += ",";
        }
        params = Helper.replaceTextFromArray(params, this.sortOptions);
      }
      return params;
    },
  },

  watch: {
    endpoint: {
      async handler() {
        if (this.endpoint) {
          this.pagination.url = this.endpoint;
          this.getAllItems();
        }
      },
    },

    options: {
      async handler() {
        // this.$emit('update:tableOptions', this.options)
        if (this.enablePagination) {
          this.pagination.url = Helper.addUrlParams(
            this.endpoint,
            "page=" + this.options.page
          );
          // this.pagination.url =
          // endpoints.getAllFeeRecords + "?page=" + this.options.page;
          var params = this.getParamsString();
          this.pagination.url += params;
          this.getAllItems();
        }
      },
    },
    search: {
      async handler() {
        if (!this.enablePagination) return;
        // console.log("search is getting called");
        this.options.page = 1;
        var searched = this.search;
        var self = this;
        setTimeout(function () {
          if (searched == self.search) {
            self.getAllItems();
          }
        }, 500);
      },
    },
  },
  created() {
    // this.getAllItems(); // <- called in options watch
    console.log(this.enablePagination);
    if (!this.enablePagination) {
      // To turn off options and backend search
      this.getAllItems();
    }
    this.$emit("getAllItemsFunction", this.getAllItems);
    if (Object.keys(this.filterData).length > 0) {
      Object.keys(this.filterData).map(async (field) => {
        var fieldData = this.filterData[field];
        if (fieldData.endpoint) {
          fieldData.items = await api.call(this.essentials, fieldData.endpoint);
        }
      });
    }
  },
};
</script>
<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>